import { addressGroupProvider }  from './addressGroup';
import { sameAsAboveProvider }   from './sameAsAbove';
import { datePolicyProvider }    from './datePolicies';
import { settingsRulesProvider } from './settingsRules';

export {
  addressGroupProvider,
  sameAsAboveProvider,
  datePolicyProvider,
  settingsRulesProvider,
};

export const DEFAULT_RULE_PROVIDERS = [
  addressGroupProvider,
  sameAsAboveProvider,
  datePolicyProvider,
  settingsRulesProvider,
];